/**
 * Custom scrollbar styles for scrollable question areas.
 * Applies to answer options, matrix content, and large rating blocks.
 *
 * Uses webkit scrollbar pseudo-elements for Chrome/Safari/Edge.
 */
export const scrollbarCSS = `
    /* ===== Answer options scrollbar ===== */
    .ph-options::-webkit-scrollbar {
        width: 6px;
    }

    .ph-options::-webkit-scrollbar-track {
        background-color: #DADBDD;
        border-radius: 100px;
    }

    .ph-options::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background-color: #9EA0A3;
    }

    /* ===== Matrix scrollbar ===== */
    .ph-matrix::-webkit-scrollbar {
        width: 6px;
    }

    .ph-matrix::-webkit-scrollbar-track {
        background-color: #DADBDD;
        border-radius: 100px;
    }

    .ph-matrix::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background-color: #9EA0A3;
    }

    /* ===== Rating (large scale) scrollbar ===== */
    .ph-rating--large::-webkit-scrollbar {
        width: 6px;
    }

    .ph-rating--large::-webkit-scrollbar-track {
        background-color: #DADBDD;
        border-radius: 100px;
    }

    .ph-rating--large::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background-color: #9EA0A3;
    }
`;
